export default {
  watch: {
    selectedHeaders (v) {
      window.localStorage.setItem(`selectedHeaders-${this.$route.name}`, JSON.stringify(this.selectedHeaders))
    }
  },

  mounted () {
    const saved = window.localStorage.getItem(`selectedHeaders-${this.$route.name}`)

    if (saved) {
      this.selectedHeaders = JSON.parse(saved)
    }
  }
}
